import { render, staticRenderFns } from "./ProfilesTable.vue?vue&type=template&id=8e4ec276&scoped=true&"
import script from "./ProfilesTable.vue?vue&type=script&lang=js&"
export * from "./ProfilesTable.vue?vue&type=script&lang=js&"
import style0 from "./ProfilesTable.vue?vue&type=style&index=0&id=8e4ec276&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4ec276",
  null
  
)

export default component.exports